import {
	selectRiskDetailsTablePage,
	selectorRiskDetailsRows,
} from '@Selectors/Risk.selectors';
import { useSelector } from 'react-redux';
import { useResultsGridFlags } from './useResultsGridFlags';

export default function useRiskDetailsRows() {
	const tablePage = selectRiskDetailsTablePage();
	const { showDriverColumns } = useResultsGridFlags();

	const risks = useSelector(selectorRiskDetailsRows);

	const rows =
		tablePage.cells.map((row: string[], nRow: number) => {
			const WEIGHTED_SCORES = risks[nRow].WEIGHTED_SCORES;

			return {
				id: nRow,
				ASSET_ID: row[0],
				RISK_CHANGE: row[1],
				CURRENT_RISK: row[2],
				CURRENT_LOF: row[3],
				CURRENT_COF: row[4],
				CONDITION_DATA: row[5],
				GRADE: row[6],
				Menu: row[0],
				MATERIAL: risks[nRow]?.MATERIAL ?? null,
				DIAMETER: risks[nRow]?.DIAMETER ?? null,
				INSTALLATION_YEAR: risks[nRow]?.INSTALLATION_YEAR ?? null,
				CCTV_INSPECTED: risks[nRow]?.CCTV_INSPECTED ?? null,
				LAST_INSPECTED: risks[nRow]?.LAST_INSPECTED ?? null,
				INSPECTION_RERUN_NEEDED:
					risks[nRow]?.INSPECTION_RERUN_NEEDED === true,
				DATA_COVERAGE: risks[nRow]?.DATA_COVERAGE ?? null,
				...(showDriverColumns && WEIGHTED_SCORES),
			};
		}) || [];

	return rows;
}
